<template>
  <div class="py-4">
    <div v-for="(dailyCommunications, dateStamp) in communicationsByDate" :key="dateStamp">
      <div class="mt-4 mb-2 text-sm sticky top-4px flex justify-center opacity-75 z-10">
        <div class="text-center bg-white rounded p-2">
          {{dateStamp}}
        </div>
      </div>
      <TransitionGroup
        tag="ul"
        class="py-4"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="hidden"
      >
        <component
          v-for="communication in dailyCommunications"
          class="transform transition-all duration-300 ease-in-out"
          :is="communication.__typename"
          :communication="communication"
          :key="communication.id"
          v-observe-visibility="(isVisible, entry) => communicationVisibilityChanged(isVisible, entry, communication.id)"
        >
        </component>
      </TransitionGroup>
    </div>
  </div>
</template>

<script>
import _get from 'lodash-es/get'
import _groupBy from 'lodash-es/groupBy'
import _nth from 'lodash-es/nth'
import _kebabCase from 'lodash-es/kebabCase'
import Message    from '@/components/Message.vue'
import PhoneCall from '@/components/PhoneCall.vue'
import parse from 'date-fns/parse'

export default {
  components: {
    Message,
    PhoneCall
  },

  props: {
    communications: {
      type: Array,
      default: () => { [] }
    },
    didLoadMore: {
      type: Function,
      default: () => { console.warn("Cardstock: [warn] unhandled didLoadMore in CommunicationList") }
    }
  },

  data: function() {
    return {
      needsToScroll: true,
      position: null
    }
  },

  computed: {
    communicationsByDate() {
      return _groupBy(this.communications, (c) => {
        return parse(c.insertedAt).toLocaleString('en-US', {month: 'short', day: 'numeric', year: 'numeric'})
      })
    },

    firstId() {
      var first = _nth(this.communications, 0)
      return _get(first, 'id')
    },

    loadMoreTriggerId() {
      var trigger = _nth(this.communications, 20)
      return _get(trigger, 'id')
    }
  },

  methods: {
    communicationVisibilityChanged(isVisible, entry, id) {
      if ((isVisible && id == this.loadMoreTriggerId) || (isVisible && id == this.firstId)) {
        console.log("Cardstock: CommunicationList - Scrolling to communication ID " + id + " triggered didLoadMore")
        this.didLoadMore()
      }
    },

    kebab: function (string) {
      return _kebabCase(string)
    },

    getNthTimestampDate(n) {
      const nth = _nth(this.communications, n)
      const insertedAt = _get(nth, 'insertedAt')
      return parse(insertedAt).toLocaleString('en-US', {month: 'short', day: 'numeric', year: 'numeric'})
    },

    needsDateStamp(index) {
      return index === 0 || this.getNthTimestampDate(index - 1) != this.getNthTimestampDate(index)
    },

    formattedDateStamp(dateStamp) {
      if (isToday(dateStamp)) {
        return "Today"
      } else if (isYesterday(dateStamp)) {
        return "Yesterday"
      } else {
        return parse(dateStamp).toLocaleString('en-US', {month: 'short', day: 'numeric', year: 'numeric'})
      }
    },

    component_type(communication) {
      if (communication.type == "message") {
        return "message"
      } else if (communication.type == "phone_call") {
        return "phoneCall"
      }
    }
  }
}
</script>
